import { Channel } from "components/chat/Channel";
import Slider from "components/DesignSystem/Slider/Slider";
import { KnowledgeBaseActiveIcon } from "components/icons/KnowledgeBaseActiveIcon";
import { KnowledgeBaseIcon } from "components/icons/KnowledgeBaseIcon";
import { SidebarStickyItem } from "components/Sidebar/SidebarStickyItem";
import { useModal } from "hooks/useModal";
import { useGetUserProfileQuery } from "store/apis/profile";
import { stopPropagation } from "utils/stopPropagation";

const KBIcon = () => <KnowledgeBaseIcon size="16" />;

export const KnowledgeBaseNavItem = () => {
  const slider = useModal();
  const { data: userProfile } = useGetUserProfileQuery();

  const kbChannelUrl = userProfile?.kb_channel_url ?? null;

  if (!kbChannelUrl) {
    return null;
  }

  return (
    <div onClick={stopPropagation}>
      <SidebarStickyItem
        icon={KBIcon}
        label="Knowledge Base"
        onClick={slider.open}
      />

      <Slider.Root open={slider.isOpen} onOpenChange={slider.toggle}>
        <Slider.Content withOverlay width={600}>
          <Slider.Header>
            <div className="t-flex t-items-center t-gap-2">
              <KnowledgeBaseActiveIcon size="22" />
              <Slider.Title>Knowledge Base</Slider.Title>
            </div>
            <Slider.Close />
          </Slider.Header>
          <div className="t-h-full t-overflow-hidden">
            <Channel
              channelId={kbChannelUrl}
              Header={() => null}
              messageMaxWidth="360px"
            />
          </div>
        </Slider.Content>
      </Slider.Root>
    </div>
  );
};
